module.exports = __webpack_public_path__ + "img/16d001-20.829db692.png";